import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { push } from '@lagunovsky/redux-react-router'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { darkBlue, mainBlue } from 'utils/constants/ColorTheme'
import { Icon, Tooltip, Grid, Typography, Chip } from '@mui/material'
import { hasValue } from 'utils/NumberUtil'
import { getTextColorByBackground } from 'utils/ColorUtil'

// const $ = window.$

const SlideNavLink = ({
    id = '',
    href = '',
    name = '',
    className = '',
    icon = '',
    tooltip = true,
    external = false,
    chipValue,
    chipColor,
    chipFontColor,
    'data-cy': dataCy = '',
}) => {
    const dispatch = useDispatch()
    const { pathname } = useLocation()

    const isSelected = useMemo(() => {
        if (external) return false
        if (href === '/') {
            return pathname === href
        }
        return pathname.startsWith(href)
    }, [pathname, href, external])

    return (
        <li className={className} style={{ padding: '5px' }}>
            <Tooltip disableHoverListener={!tooltip} title={name} placement='right'>
                <Grid
                    onClick={() => external ? window.open(href, 'blank') : dispatch(push(href))}
                    data-cy={dataCy}
                    sx={{
                        height: '30px',
                        padding: '0 10px',
                        cursor: 'pointer',
                        borderRadius: '10px',
                        backgroundColor: isSelected ? 'lightgrey' : 'white',
                        '&:hover': {
                            backgroundColor: 'lightgrey',
                        },
                    }}
                    container
                    alignItems='center'
                >
                    <Grid container size={'grow'} spacing={1} justifyContent='flex-start' alignItems={'center'}>
                        {!!icon && <Icon id={id} sx={{ fontSize: '24px', color: isSelected ? darkBlue : 'grey' }}>{icon}</Icon>}
                        <Typography
                            fontSize='14px'
                            color='black'
                            noWrap
                        >{name}</Typography>
                    </Grid>
                    {hasValue(chipValue) && (
                        <Chip
                            label={chipValue}
                            size={'small'}
                            sx={{
                                backgroundColor: chipColor ?? mainBlue,
                                color: chipFontColor ?? getTextColorByBackground(chipColor ?? mainBlue),
                            }}
                        />
                    )}
                </Grid>
            </Tooltip>
        </li>
    )
}

SlideNavLink.propTypes = {
    id: PropTypes.string,
    href: PropTypes.string.isRequired,
    name: PropTypes.string,
    className: PropTypes.string,
    icon: PropTypes.string,
    external: PropTypes.bool,
    tooltip: PropTypes.bool,
    chipValue: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.element,
    ]),
    chipColor: PropTypes.string,
    chipFontColor: PropTypes.string,

    'data-cy': PropTypes.string,
}

export default SlideNavLink